var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 582 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352 128.4 L319.7 96 L160 256 L160 256 L160 256 L319.7 416 L352 383.6 L224.7 256"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 441 50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 78.4 L269.7 46 L110 206 L110 206 L110 206 L269.7 366 L302 333.6 L174.7 206"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchNextIcon);
export default __webpack_public_path__ + "static/media/MatchNextIcon.0d8040f60b92c1b40260845bd444e534.svg";
export { ForwardRef as ReactComponent };